import React from 'react';

import { Helmet } from 'react-helmet';
import { Global, css } from '@emotion/react';
import { withPrefix } from 'gatsby';

const fonts = [
  'Graphik-Bold-Cy-Web.woff2',
  'Graphik-Light-Cy-Web.woff2',
  'Graphik-Medium-Cy-Web.woff2',
  'Graphik-Regular-Cy-Web.woff2',
  'Graphik-RegularItalic-Cy-Web.woff2',
  'Graphik-Semibold-Cy-Web.woff2',
  'Graphik-SemiboldItalic-Cy-Web.woff2',
];

const FontLoader = () => (
  <>
    <Global
      // eslint-disable-next-line @emotion/syntax-preference
      styles={css`
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-Light-Cy-Web.woff2')}) format('woff2');
          font-weight: 300;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-Regular-Cy-Web.woff2')}) format('woff2');
          font-weight: 400;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-RegularItalic-Cy-Web.woff2')}) format('woff2');
          font-weight: 400;
          font-style: italic;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-Medium-Cy-Web.woff2')}) format('woff2');
          font-weight: 500;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-Semibold-Cy-Web.woff2')}) format('woff2');
          font-weight: 600;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-SemiboldItalic-Cy-Web.woff2')}) format('woff2');
          font-weight: 600;
          font-style: italic;
        }
        @font-face {
          font-family: 'Graphik';
          src: url(${withPrefix('/fonts/Graphik-Bold-Cy-Web.woff2')}) format('woff2');
          font-weight: 700;
        }
      `}
    />
    <Helmet>
      {fonts.map(font => (
        <link
          key={font}
          as="font"
          crossOrigin="anonymous"
          href={withPrefix(`/fonts/${font}`)}
          rel="preload"
          type="font/woff2"
        />
      ))}
    </Helmet>
  </>
);

export { FontLoader };
export default FontLoader;
